import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  useDeleteMerchDistributionTemplate,
  useGetMerchDistributionSectionTemplate,
} from 'services/templates/merch-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { onErrorShowToast } from 'utils/service/errorHandler';

const MerchDistributionTemplateSection = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const merchDistribution = useGetMerchDistributionSectionTemplate(id);

  const removeMerchDistribution = useDeleteMerchDistributionTemplate(id);

  const onRemoveMerchDistributionTemplate = async (actions: PopupActions) => {
    await removeMerchDistribution.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate('/templates-extended'),
    });
  };

  return (
    <Form.Contract
      tittle={
        merchDistribution.data?.title ??
        t('contract-template.merchDistributionDistribution.title')
      }
      backPath='templates-extended'
      topbarContent={
        <div className='flex'>
          <Button
            isClear
            onlyIcon
            onClick={() =>
              navigate(
                `/templates-extended/merch-distribution/edit/${id}/form`,
                {
                  replace: true,
                }
              )
            }>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
          <MagellanPopups.DeleteWarning
            onRemove={onRemoveMerchDistributionTemplate}
            removeLoading={merchDistribution.isPending}
            name={merchDistribution.data?.title}
          />
        </div>
      }
      initialStatus={{
        ...contractTemplateUtil.distribution.initialStatus,
        displayMode: true,
      }}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: merchDistribution.data
          ? middleware.template.merchDistribution.queryToForm(
              merchDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(
              TEMPLATE_TYPE.merchDistribution
            ),
      }}
      onSubmit={() => {}}
      status={{ isLoading: merchDistribution.isLoading, displayMode: true }}
    />
  );
};

export default MerchDistributionTemplateSection;
